import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import get from 'lodash/get';
import find from 'lodash/find';
import { getDeviceType, getVersion } from './DigitalAnalyticsHelper';

const configSourceToPageMap = {
    // source : pageName
    details: 'order details',
    orderlist: 'order history',
};

export class UpdatePaymentActionFilter extends BaseActionFilter {
    updatePaymentSliderDL(store, payload = {}) {
        const { context } = store.getState();

        const deviceType = getDeviceType(context);

        const jcpCloudEnv = get(context, 'preferences.environment', '');

        const { source } = payload;

        const getUpdatePaymentSliderDL = this.updateCommonDigitalData();
        getUpdatePaymentSliderDL.page.pageInfo.pageName = 'payment update slider';
        getUpdatePaymentSliderDL.page.pageInfo.pageType = 'account';
        getUpdatePaymentSliderDL.page.pageInfo.siteSection = configSourceToPageMap[source] || '';
        getUpdatePaymentSliderDL.page.pageInfo.deviceType = deviceType;
        getUpdatePaymentSliderDL.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        getUpdatePaymentSliderDL.page.pageInfo.searchRedirect = '';
        getUpdatePaymentSliderDL.page.pageInfo.version = getVersion('yoda post-purchase');
        getUpdatePaymentSliderDL.page.pageInfo.productionCluster =
            jcpCloudEnv && jcpCloudEnv.indexOf('prod') !== -1 ? 'yes' : 'no';

        getUpdatePaymentSliderDL.page.category = {};
        getUpdatePaymentSliderDL.page.category.primaryCategory = 'account';
        getUpdatePaymentSliderDL.page.category.department = 'account';
        return getUpdatePaymentSliderDL;
    }

    submitUpdatePaymentDL = (store, payload = {}) => {
        const { context } = store.getState();
        const getSubmitUpdatePaymentDL = {
            page: {
                pageInfo: {},
            },
        };
        const { billing = [] } = payload;
        const revenue = get(get(billing[0], 'creditCards', [])[0], 'amount', '');
        const paymentMethod = get(get(billing[0], 'creditCards', [])[0], 'cardStorage', '');
        const totalOrderAmount =
            find(
                get(store.getState(), 'orderDetails.payload.priceInfo', []),
                (priceItem) => priceItem.code === 'ORDER AMOUNT'
            ) || {};
        getSubmitUpdatePaymentDL.page.pageInfo.revenue = revenue
            ? revenue.toFixed(2)
            : revenue.toString();
        getSubmitUpdatePaymentDL.page.pageInfo.paymentMethod =
            paymentMethod ===
            get(context, 'messagesTexts.updatePayment.cardStorageOptions.storedCard', '')
                ? 'existing'
                : 'new';
        getSubmitUpdatePaymentDL.page.pageInfo.typeOfPayment =
            totalOrderAmount.value === revenue ? 'full' : 'partial';
        return getSubmitUpdatePaymentDL;
    };

    getUpdatePaymentFormErrorDL = (store, payload = {}) => {
        const getFormErrorDL = { error: [] };
        const { context } = store.getState();
        getFormErrorDL.error.push({
            errorDescription: get(context, 'messagesTexts.updatePayment.errorMessages.DEFAULT', ''),
            errorID: payload.errorCode || '',
        });
        return getFormErrorDL;
    };
}
export default UpdatePaymentActionFilter;
